// DO NOT EDIT THIS FILE!!!
angular.module('config')
	.constant('URL_PREFIX', '/endp');
angular.module('config')
	.constant('USE_MOCKS', false);
